import { palette } from './palette'

export type TTextContrast = 'low' | 'default' | 'high'

/**
 * @public
 */
export const colors = {
  default: {
    'gradient-inverse-from': {
      DEFAULT: '#000',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FFF',
    },
    'icon-contrast-lower': {
      DEFAULT: palette.gray[400],
      dark: palette.gray[500],
    },
    'text-contrast-low': {
      DEFAULT: palette.gray[600],
      dark: palette.gray[400],
    },
    'text-contrast-default': {
      DEFAULT: palette.gray[800],
      dark: palette.gray[200],
    },
    'text-contrast-high': {
      DEFAULT: palette.gray[900],
      dark: palette.gray[50],
    },
    'text-placeholder': {
      DEFAULT: palette.gray['064'],
      dark: palette.white['064'],
    },
    'label-light': {
      DEFAULT: palette.gray[600],
      dark: palette.gray[300],
    },
    'label-light-contrast-low': {
      DEFAULT: palette.gray[500],
      dark: palette.gray[400],
    },
    'label-solid': {
      DEFAULT: palette.white['white'],
      dark: palette.gray[900],
    },
    'bg-light': {
      DEFAULT: palette.gray[50],
      dark: palette.gray[900],
    },
    'bg-medium': {
      DEFAULT: palette.gray[100],
      dark: palette.gray[800],
    },
    'bg-high': {
      DEFAULT: palette.gray[200],
      dark: palette.gray[700],
    },
    'bg-inverse': {
      DEFAULT: palette.gray[500],
      dark: palette.gray[400],
    },
    'bg-loading': {
      DEFAULT: '#f0eeed',
      dark: '#e1dedc',
    },
    'button-solid': {
      DEFAULT: palette.gray[500],
      dark: palette.gray[400],
    },
    'button-solid-hover': {
      DEFAULT: palette.gray[600],
      dark: palette.gray[300],
    },
    'input-unfocus': {
      DEFAULT: palette.gray[400],
      dark: palette.gray[500],
    },
    'input-focus': {
      DEFAULT: palette.gray[600],
      dark: palette.gray[300],
    },
    'icon-button-bg': {
      DEFAULT: palette.gray['008'],
      dark: palette.white['008'],
    },
    'text-white': {
      DEFAULT: palette.white['white'],
      dark: palette.gray[900],
    },
    'bg-white': {
      DEFAULT: palette.white['white'],
      dark: palette.gray[900],
    },
  },
  primary: {
    'gradient-inverse-from': {
      DEFAULT: '#F08100',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FFB119',
    },
    'gradient-inverse-high-from': {
      DEFAULT: '#CA6100',
    },
    'gradient-inverse-high-to': {
      DEFAULT: '#FAA500',
    },
    'gradient-light-from': {
      DEFAULT: '#FFFCED',
    },
    'gradient-light-to': {
      DEFAULT: '#FFF5EB',
    },
    'gradient-medium-from': {
      DEFAULT: '#FFF0C7',
    },
    'gradient-medium-to': {
      DEFAULT: '#FFDAB9',
    },
    'gradient-high-from': {
      DEFAULT: '#FFC78F',
    },
    'gradient-high-to': {
      DEFAULT: '#FFE18F',
    },
    'page-title': {
      DEFAULT: palette.amber[500],
      dark: palette.amber[400],
    },
    'icon-contrast-lower': {
      DEFAULT: palette.amber[500],
      dark: palette.amber[400],
    },
    'text-contrast-low': {
      DEFAULT: palette.amber[700],
      dark: palette.amber[200],
    },
    'text-contrast-default': {
      DEFAULT: palette.amber[800],
      dark: palette.amber[100],
    },
    'text-contrast-high': {
      DEFAULT: palette.amber[900],
      dark: palette.amber[50],
    },
    'text-placeholder': {
      DEFAULT: palette.amber['064'],
      dark: palette.amber['064'],
    },
    'label-solid': {
      DEFAULT: palette.white['white'],
      dark: palette.amber[900],
    },
    'label-light': {
      DEFAULT: palette.amber[700],
      dark: palette.amber[200],
    },
    'label-light-contrast-low': {
      DEFAULT: palette.amber[500],
      dark: palette.amber[400],
    },
    'bg-light': {
      DEFAULT: palette.amber[50],
      dark: palette.amber[900],
    },
    'bg-medium': {
      DEFAULT: '#FFF2D8',
      dark: palette.amber[800],
    },
    'bg-high': {
      DEFAULT: palette.amber[200],
      dark: palette.amber[700],
    },
    'bg-inverse': {
      DEFAULT: palette.amber[500],
      dark: palette.amber[400],
    },
    'input-unfocus': {
      DEFAULT: palette.amber[400],
      dark: palette.amber[500],
    },
    'input-focus': {
      DEFAULT: palette.amber[600],
      dark: palette.amber[300],
    },
    'icon-button-bg': {
      DEFAULT: palette.amber['008'],
      dark: palette.white['008'],
    },
  },
  secondary: {
    'gradient-inverse-from': {
      DEFAULT: '#000',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FFF',
    },
    'icon-contrast-lower': {
      DEFAULT: palette.blue[400],
      dark: palette.blue[500],
    },
    'text-contrast-low': {
      DEFAULT: palette.blue[500],
      dark: palette.blue[400],
    },
    'text-contrast-default': {
      DEFAULT: palette.blue[800],
      dark: palette.blue[100],
    },
    'text-contrast-high': {
      DEFAULT: palette.blue[900],
      dark: palette.blue[50],
    },
    'text-placeholder': {
      DEFAULT: palette.blue['064'],
      dark: palette.blue['064'],
    },
    'label-solid': {
      DEFAULT: palette.white['white'],
      dark: palette.blue[900],
    },
    'label-faded': {
      DEFAULT: palette.amber[400],
      dark: palette.amber[500],
    },
    'label-light': {
      DEFAULT: palette.blue[600],
      dark: palette.blue[300],
    },
    'label-light-contrast-low': {
      DEFAULT: palette.blue[500],
      dark: palette.blue[400],
    },
    'bg-light': {
      DEFAULT: palette.blue[50],
      dark: palette.blue[900],
    },
    'bg-medium': {
      DEFAULT: palette.blue[100],
      dark: palette.blue[800],
    },
    'bg-high': {
      DEFAULT: palette.blue[200],
      dark: palette.blue[700],
    },
    'bg-inverse': {
      DEFAULT: palette.blue[600],
      dark: palette.blue[300],
    },
    'button-solid': {
      DEFAULT: palette.blue[600],
      dark: palette.blue[300],
    },
    'button-solid-hover': {
      DEFAULT: palette.blue[700],
      dark: palette.blue[200],
    },
    'input-unfocus': {
      DEFAULT: palette.blue[400],
      dark: palette.blue[500],
    },
    'input-focus': {
      DEFAULT: palette.blue[600],
      dark: palette.blue[300],
    },
    'icon-button-bg': {
      DEFAULT: palette.blue['008'],
      dark: palette.white['008'],
    },
  },
  success: {
    'gradient-inverse-from': {
      DEFAULT: '#000',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FFF',
    },
    'icon-contrast-lower': {
      DEFAULT: palette.green[400],
      dark: palette.green[500],
    },
    'text-contrast-low': {
      DEFAULT: palette.green[600],
      dark: palette.green[400],
    },
    'text-contrast-default': {
      DEFAULT: palette.green[700],
      dark: palette.green[200],
    },
    'text-contrast-high': {
      DEFAULT: palette.green[900],
      dark: palette.green[50],
    },
    'text-placeholder': {
      DEFAULT: palette.green['064'],
      dark: palette.green['064'],
    },
    'label-solid': {
      DEFAULT: palette.white['white'],
      dark: palette.green[900],
    },
    'label-light': {
      DEFAULT: palette.green[600],
      dark: palette.green[300],
    },
    'label-light-contrast-low': {
      DEFAULT: palette.green[500],
      dark: palette.green[400],
    },
    'bg-light': {
      DEFAULT: palette.green[50],
      dark: palette.green[900],
    },
    'bg-medium': {
      DEFAULT: palette.green[100],
      dark: palette.green[800],
    },
    'bg-high': {
      DEFAULT: palette.green[200],
      dark: palette.green[700],
    },
    'bg-inverse': {
      DEFAULT: palette.green[500],
      dark: palette.green[400],
    },
    'button-solid': {
      DEFAULT: palette.green[600],
      dark: palette.green[300],
    },
    'button-solid-hover': {
      DEFAULT: palette.green[700],
      dark: palette.green[200],
    },
    'input-unfocus': {
      DEFAULT: palette.green[400],
      dark: palette.green[500],
    },
    'input-focus': {
      DEFAULT: palette.green[600],
      dark: palette.green[300],
    },
    'icon-button-bg': {
      DEFAULT: palette.green['008'],
      dark: palette.white['008'],
    },
  },
  danger: {
    'gradient-inverse-from': {
      DEFAULT: '#000',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FFF',
    },
    'icon-contrast-lower': {
      DEFAULT: palette.red[400],
      dark: palette.red[500],
    },
    'text-contrast-low': {
      DEFAULT: palette.red[500],
      dark: palette.red[400],
    },
    'text-contrast-default': {
      DEFAULT: palette.red[700],
      dark: palette.red[200],
    },
    'text-contrast-high': {
      DEFAULT: palette.red[900],
      dark: palette.red[50],
    },
    'text-placeholder': {
      DEFAULT: palette.red['064'],
      dark: palette.red['064'],
    },
    'label-solid': {
      DEFAULT: palette.white['white'],
      dark: palette.red[900],
    },
    'label-light': {
      DEFAULT: palette.red[600],
      dark: palette.red[300],
    },
    'label-light-contrast-low': {
      DEFAULT: palette.red[500],
      dark: palette.red[400],
    },
    'bg-light': {
      DEFAULT: palette.red[50],
      dark: palette.red[900],
    },
    'bg-medium': {
      DEFAULT: palette.red[100],
      dark: palette.red[800],
    },
    'bg-high': {
      DEFAULT: palette.red[200],
      dark: palette.red[700],
    },
    'bg-inverse': {
      DEFAULT: '#E12D39',
      dark: '#F86A6A',
    },
    'button-solid': {
      DEFAULT: palette.red[600],
      dark: palette.red[300],
    },
    'button-solid-hover': {
      DEFAULT: palette.red[700],
      dark: palette.red[200],
    },
    'input-unfocus': {
      DEFAULT: palette.red[400],
      dark: palette.red[500],
    },
    'input-focus': {
      DEFAULT: palette.red[600],
      dark: palette.red[300],
    },
    'icon-button-bg': {
      DEFAULT: palette.red['008'],
      dark: palette.white['008'],
    },
  },
  leonxivfr: {
    DEFAULT: '#173E8F',
    light: '#F0F4FA',
  },
  transparent: palette.white['000'],
  content: {
    link: {
      DEFAULT: '#3283E3',
      dark: '#3283E3',
    },
  },
  layout: {
    overlay: {
      DEFAULT: palette.gray['008'],
      dark: palette.white['008'],
    },
    focus: {
      DEFAULT: '#4ba3e3',
      dark: '#4ba3e3',
    },
    divider: {
      DEFAULT: palette.gray['004'],
      dark: palette.white['004'],
    },
    'divider-contrast-medium': {
      DEFAULT: palette.gray['008'],
      dark: palette.white['008'],
    },
    'divider-contrast-high': {
      DEFAULT: palette.gray['016'],
      dark: palette.white['016'],
    },
    'stroke-contrast-low': {
      DEFAULT: palette.gray['002'],
      dark: palette.white['002'],
    },
    'stroke-contrast-medium': {
      DEFAULT: palette.gray['008'],
      dark: palette.white['008'],
    },
    'stroke-bordered': {
      DEFAULT: palette.gray['700'],
      dark: palette.white['008'],
    },
    'bg-loading': {
      DEFAULT: palette.gray['008'],
      dark: palette.white['008'],
    },
    background: palette.gray['50'],
  },
  accents: {
    red: {
      strong: '#C11F25',
      default: '#EA6C70',
      subtle: '#FFDBDE',
      surface: '#FFF0F1',
    },
    orange: {
      strong: '#BE4B04',
      default: '#F5843D',
      subtle: '#FFE8D1',
      surface: '#FFF2E5',
    },
    rust: {
      strong: '#9E6F00',
      default: '#D69600',
      subtle: '#FFEFBD',
      surface: '#FFF7DB',
    },
    yellow: {
      strong: '#8A8300',
      default: '#C2B500',
      subtle: '#FAF19E',
      surface: '#FDF8CE',
    },
    lime: {
      strong: '#628203',
      default: '#8AB30F',
      subtle: '#E5F6A7',
      surface: '#F1FAD1',
    },
    green: {
      strong: '#20925C',
      default: '#37C380',
      subtle: '#CFFCD1',
      surface: '#E2FDE3',
    },
    teal: {
      strong: '#108AA2',
      default: '#1FC0E0',
      subtle: '#C3F9FB',
      surface: '#E2FCFD',
    },
    blue: {
      strong: '#3671BF',
      default: '#5999F7',
      subtle: '#D1E1FF',
      surface: '#EBF2FF',
    },
    violet: {
      strong: '#6958CA',
      default: '#907EF7',
      subtle: '#DDD1FF',
      surface: '#F4F0FF',
    },
    purple: {
      strong: '#8F56AE',
      default: '#CA79F6',
      subtle: '#F0D1FF',
      surface: '#F8EBFE',
    },
    pink: {
      strong: '#B7386D',
      default: '#EC79A9',
      subtle: '#FCE0FF',
      surface: '#FDF0FF',
    },
  },
  social: {
    whatsapp: {
      50: '#F2FFF3',
      100: '#D6F7D9',
      600: '#41C452',
      700: '#26B038',
    },
  },
  multicolor: {
    'gradient-inverse-from': {
      DEFAULT: '#D160E8',
    },
    'gradient-inverse-via': {
      DEFAULT: '#36AFF0',
    },
    'gradient-inverse-to': {
      DEFAULT: '#FF9400',
    },
  },
}

export type TMainColor = 'primary' | 'secondary' | 'success' | 'danger' | 'default'
